import { appVersion } from "../appVersion";
import sampleData from "../sampleData.json";
import bcrypt from "bcryptjs-react";
const secretUrls = `/.netlify/functions/secretUrls`;

//Set to false to turn off tracking (use while testing UI). Set to true when pushing code up.
const logActivityRunning = true;

const logActivity = ({
  apiKey,
  userEmail,
  userType,
  tab,
  action,
  userCompany,
}) => {
  if (logActivityRunning && userEmail.toLowerCase() != "blake@smith.com") {
    fetch(secretUrls, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        fetch(data.logActivityUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            apiKey: apiKey,
            userEmail: userEmail,
            userType: userType,
            tab: tab,
            action: action,
            appVersion: appVersion,
            userCompany: userCompany,
          }),
        });
      });
  }
};

const updateUserSettings = ({ apiKey, userType, userId, field, value }) => {
  if (userId != "") {
    fetch(secretUrls, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        fetch(data.userSettingsUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            apiKey: apiKey,
            userType: userType,
            userId: userId,
            field: field,
            value: value,
          }),
        });
      });
  } else {
  }
};

const sendTextNotification = ({
  textNotificationsAllowed,
  textMessage,
  textPhone,
}) => {
  if (textPhone != "333-555-6165") {
    if (textNotificationsAllowed) {
      fetch(secretUrls, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const urlencoded = new URLSearchParams();
          urlencoded.append("To", textPhone);
          urlencoded.append("From", data.sendText.accountPhone);
          urlencoded.append("Body", textMessage);
          fetch(data.sendText.url, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Basic ${window.btoa(
                `${data.sendText.accountSid}:${data.sendText.accountToken}`
              )}`,
            },
            body: urlencoded,
            redirect: "follow",
          })
            .then((response) => response.text())
            .catch((error) => console.log("error", error));
        });
    }
  } else {
    console.log("blake texted");
  }
};

function getUserId({
  setUserId,
  userEmail,
  userType,
  makeKey,
  userPassword,
  movePassword,
  setLoginModalInputs,
  setMatrixData,
  setLoginModalAction,
  setModal,
  setNavbar,
  setMidbar,
  setUserEmail,
  setUserPhone,
  setTextNotifications,
  setUserCompany,
  setUserCompanyId,
  setUserPassword,
  setUserName,
  setMakeKey,
  setPath,
  navigate,
  setClientSelection,
  path,
  clientSelection,
  setFubId,
  setFubKey,
  action,
  actionTab,
  setTeamMemberSelected,
  setTeamMemberSelectedInfo,
  setTeamPermissions,
  setBuyersGuide,
  setBuyersGuideEditable,
}) {
  setModal("active");
  setLoginModalInputs([["loadingData", "Loading your data...", "none"]]);
  if (
    String(userEmail).toLowerCase() === "blake@smith.com" &&
    userPassword === "b1ak3"
  ) {
    const samplePreApprovals = JSON.stringify(sampleData[0]["Clients"]);
    const sampleUnderContract = JSON.stringify(sampleData[0]["UnderContract"]);
    const jsonSampleData = [
      {
        Clients: samplePreApprovals,
        UnderContract: sampleUnderContract,
      },
    ];
    setMatrixData(jsonSampleData);
    setLoginModalAction("");
    setModal("inactive");
    setNavbar("nav-bar");
    setMidbar("mid-bar");
    setUserEmail(userEmail);
    setUserPassword(userPassword);
    setUserCompany(sampleData[0]["Company"]);
    setUserCompanyId(sampleData[0]["Company ID"]);
    setUserPhone(sampleData[0]["User Phone"]);
    setUserName(sampleData[0]["User Name"]);
    setTeamPermissions(sampleData[0]["Team Permission"]);
    setTeamMemberSelected(sampleData[0]["User Name"]);
    setTeamMemberSelectedInfo({
      zillowFlexCertification: sampleData[0]["Zillow Flex Certification"],
      beOneOnboarding: sampleData[0]["Be One Onboarding"],
    });
    document.getElementById("LoginModalForm").reset();
    if (
      path !== "/home" ||
      path !== "/pending" ||
      path !== "/preapproved" ||
      path !== "/undercontract"
    ) {
      setPath("/home");
      navigate("/home");
    }
  } else {
    const apiKeyUrl = `/.netlify/functions/getMakeKey`;
    fetch(apiKeyUrl, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((body) => {
        setMakeKey(body.makeKey);
      });
    const getUserIdUrl = "/.netlify/functions/getUserId";
    fetch(getUserIdUrl, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((body) => {
        fetch(body.url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            userEmail: userEmail,
            userType: userType,
            apiKey: makeKey,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            const hashedPassword = data[0].hashedPassword;
            if (!hashedPassword) {
              alert(
                'New account!\n\n> Please click "Reset Password" to finish setting up your new account.'
              );
              setModal("inactive");
            } else {
              if (
                bcrypt.compareSync(userPassword, data[0].hashedPassword) ||
                userPassword === movePassword
              ) {
                const userId = data[0].userId;
                setUserEmail(userEmail);
                setUserPassword(userPassword);
                getUserInfoWithId({
                  userId: userId,
                  setUserId: setUserId,
                  setMatrixData: setMatrixData,
                  setUserName: setUserName,
                  setUserPhone: setUserPhone,
                  setTextNotifications: setTextNotifications,
                  setUserCompany: setUserCompany,
                  setUserCompanyId: setUserCompanyId,
                  setLoginModalAction: setLoginModalAction,
                  setModal: setModal,
                  userType: userType,
                  makeKey: makeKey,
                  setPath: setPath,
                  navigate: navigate,
                  setClientSelection: setClientSelection,
                  path: path,
                  clientSelection: clientSelection,
                  setFubId: setFubId,
                  setFubKey: setFubKey,
                  setTeamMemberSelected: setTeamMemberSelected,
                  setTeamMemberSelectedInfo: setTeamMemberSelectedInfo,
                  action: action,
                  userEmail: userEmail,
                  actionTab: actionTab,
                  setTeamPermissions: setTeamPermissions,
                  setBuyersGuide: setBuyersGuide,
                  setBuyersGuideEditable: setBuyersGuideEditable,
                });
                setNavbar("nav-bar");
                setMidbar("mid-bar");
              } else {
                alert(
                  'Invalid password :(\n\n>Try again or click "Reset Password" to login to account.'
                );
                setModal("inactive");
              }
            }
          })
          .catch((error) => {
            alert(
              "Login Error\nConfirm you used the email corresponding to your account and that you clicked the correct login (Agent vs Loan Officer). Otherwise, please notify mike@movemortgage.com that you received the following error code: 401"
            );
            setModal("inactive");
          });
      });
  }
}

function getUserInfoWithId({
  userId,
  setUserId,
  setMatrixData,
  setUserName,
  setUserPhone,
  setTextNotifications,
  setUserCompany,
  setUserCompanyId,
  setLoginModalAction,
  setModal,
  userType,
  makeKey,
  setPath,
  navigate,
  setClientSelection,
  path,
  clientSelection = "Pending",
  setFubId,
  setFubKey,
  setTeamMemberSelected,
  setTeamMemberSelectedInfo,
  action,
  userEmail,
  actionTab,
  setTeamPermissions,
  setBuyersGuide,
  setBuyersGuideEditable,
}) {
  let hook = "";
  if (userType === "Agent") {
    hook = `/.netlify/functions/getUserInfoWithIdAgent`;
  } else if (userType === "Loan Officer") {
    hook = `/.netlify/functions/getUserInfoWithIdLoanOfficer`;
  }

  fetch(hook, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
    .then((response) => response.json())
    .then((body) => {
      fetch(body.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          userId: userId,
          apiKey: makeKey,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setMatrixData(data);
          setUserName(data[0]["User Name"]);
          setTeamPermissions(data[0]["Team Permission"]);
          setTeamMemberSelected(data[0]["User Name"]);
          setTextNotifications(!data[0]["Text Notifications Off"]);
          setFubId(data[0]["FUB Id"]);
          setFubKey(data[0]["Company FUB Key"]);
          setUserPhone(data[0]["User Phone"]);
          setUserCompany(data[0]["Company"]);
          setUserCompanyId(data[0]["Company ID"]);
          setBuyersGuide(data[0]["Buyer's Guide"]);
          setBuyersGuideEditable(data[0]["Buyer's Guide Editable"]);
          setTeamMemberSelectedInfo({
            zillowFlexCertification: data[0]["Zillow Flex Certification"],
            beOneOnboarding: data[0]["Be One Onboarding"],
          });
          setLoginModalAction("");
          setModal("inactive");
          setUserId(userId);
          document.getElementById("LoginModalForm").reset();
          if (
            path !== "/home" ||
            path !== "/pending" ||
            path !== "/preapproved" ||
            path !== "/undercontract"
          ) {
            setPath("/home");
            navigate("/home");
          }
          setClientSelection(clientSelection);
          if (action) {
            logActivity({
              apiKey: makeKey,
              userEmail: userEmail,
              userType: userType,
              action: action,
              tab: actionTab,
              userCompany: data[0]["Company"],
            });
          }
        });
    });
}

function formatPhoneNumber(phoneNumberString) {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return null;
}

function getTeamMemberId({
  userEmail,
  userType,
  userCompany,
  makeKey,
  setLoginModalInputs,
  setMatrixData,
  setLoginModalAction,
  setModal,
  setMakeKey,
  setFubId,
  teamMemberSelected,
  setTeamMemberSelected,
  setTeamMemberSelectedInfo,
  tab,
}) {
  setModal("active");
  setLoginModalInputs([["loadingData", "Loading your data...", "none"]]);
  if (userEmail.toLowerCase() === "blake@smith.com") {
    const samplePreApprovals = JSON.stringify(sampleData[0]["Clients"]);
    const sampleUnderContract = JSON.stringify(sampleData[0]["UnderContract"]);
    const jsonSampleData = [
      {
        Clients: samplePreApprovals,
        UnderContract: sampleUnderContract,
      },
    ];
    setMatrixData(jsonSampleData);
    setLoginModalAction("");
    setModal("inactive");
    document.getElementById("LoginModalForm").reset();
  } else {
    const apiKeyUrl = `/.netlify/functions/getMakeKey`;
    fetch(apiKeyUrl, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((body) => {
        setMakeKey(body.makeKey);
      });
    const getUserIdUrl = "/.netlify/functions/getTeamMemberIdUrl";
    fetch(getUserIdUrl, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((body) => {
        fetch(body.url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            teamMemberSelected: teamMemberSelected,
            userCompany: userCompany,
            apiKey: makeKey,
            userType: userType,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            const userId = data[0].userId;
            getTeamMemberInfo({
              userId: userId,
              setMatrixData: setMatrixData,
              setLoginModalAction: setLoginModalAction,
              setModal: setModal,
              userType: userType,
              makeKey: makeKey,
              setFubId: setFubId,
              setTeamMemberSelected: setTeamMemberSelected,
              teamMemberSelected: teamMemberSelected,
              setTeamMemberSelectedInfo: setTeamMemberSelectedInfo,
            });
            logActivity({
              apiKey: makeKey,
              userEmail: userEmail,
              userType: userType,
              action: "Filter for Team Data",
              tab: tab,
              userCompany: userCompany,
            });
          })
          .catch((error) => {
            alert(
              "This user is no longer part of your team and you cannot view their pipeline! Connect with mike@movemortgage.com if this is incorrect."
            );
            setTeamMemberSelected();
            setModal("inactive");
          });
      });
  }
}

function getTeamMemberInfo({
  userId,
  setMatrixData,
  setLoginModalAction,
  setModal,
  userType,
  makeKey,
  setFubId,
  teamMemberSelected,
  setTeamMemberSelected,
  setTeamMemberSelectedInfo,
}) {
  let hook = "";
  if (userType === "Agent") {
    hook = `/.netlify/functions/getUserInfoWithIdAgent`;
  } else if (userType === "Loan Officer") {
    hook = `/.netlify/functions/getUserInfoWithIdLoanOfficer`;
  }

  fetch(hook, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
    .then((response) => response.json())
    .then((body) => {
      fetch(body.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          userId: userId,
          apiKey: makeKey,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setMatrixData(data);
          setFubId(data[0]["FUB Id"]);
          setLoginModalAction("");
          setModal("inactive");
          document.getElementById("LoginModalForm").reset();
          setTeamMemberSelected(teamMemberSelected);
          setTeamMemberSelectedInfo({
            zillowFlexCertification: data[0]["Zillow Flex Certification"],
            beOneOnboarding: data[0]["Be One Onboarding"],
          });
        });
    });
}

const getTeamIds = ({
  apiKey,
  teamPermissions,
  userCompanyId,
  setTeamArray,
}) => {
  if (teamPermissions) {
    fetch(secretUrls, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        fetch(data.getTeamIdsUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            apiKey: apiKey,
            userCompanyId: userCompanyId,
          }),
        })
          .then((response) => response.json())
          .then((data) => setTeamArray(data));
      });
  }
};

export {
  logActivity,
  updateUserSettings,
  sendTextNotification,
  getUserId,
  getUserInfoWithId,
  formatPhoneNumber,
  getTeamMemberId,
  getTeamMemberInfo,
  getTeamIds,
};
